// Fonction pour synchroniser l'image selon la valeur du champ de produit
function syncKlaviyoProductImage() {
  const input = document.getElementById('downshift-0-input');
  if (!input) return;

  const form = input.closest('form');
  if (!form) return;

  // Récupère la valeur saisie dans le champ ou sélectionnée dans le menu déroulant
  let val = input.value ? input.value.trim() : '';

  if (!val) {
    const activeOption = document.querySelector('#downshift-0-menu [aria-selected="true"]');
    if (activeOption) {
      val = activeOption.innerText.trim();
    }
  }

  if (val && form.getAttribute('data-selected-product') !== val) {
    form.setAttribute('data-selected-product', val);
  }
}

document.addEventListener('input', syncKlaviyoProductImage);
document.addEventListener('change', syncKlaviyoProductImage);
document.addEventListener('click', function() {
  setTimeout(syncKlaviyoProductImage, 100);
});

const observer = new MutationObserver(function() {
  syncKlaviyoProductImage();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['value', 'aria-expanded', 'aria-selected']
});

document.addEventListener('DOMContentLoaded', syncKlaviyoProductImage);

// Les menus déroulants Klaviyo (produit, magasin, province) filtrent leurs options selon
// le texte du champ : une fois un choix fait, seule cette option reste visible. On vide le
// champ à l'ouverture du menu pour afficher toute la liste, puis on rétablit le choix
// précédent si l'utilisateur quitte le champ sans sélectionner une autre option.
const previousKlaviyoDropdownValues = new WeakMap();

function getKlaviyoDropdown(element) {
  if (!(element instanceof Element)) return null;
  const field = element.closest('[data-testid="form-component"]');
  if (!field) return null;
  const input = field.querySelector('input[role="combobox"][id^="downshift-"]');
  return input ? { field: field, input: input } : null;
}

function setKlaviyoDropdownValue(input, value) {
  // Setter natif + événement input pour que Klaviyo (React) prenne la valeur en compte
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  setter.call(input, value);
  input.dispatchEvent(new Event('input', { bubbles: true }));
}

function showAllKlaviyoDropdownOptions(event) {
  const dropdown = getKlaviyoDropdown(event.target);
  if (!dropdown) return;
  if (event.target !== dropdown.input && !event.target.closest('[id$="-toggle-button"]')) return;

  const input = dropdown.input;
  // Attend que Klaviyo ait ouvert le menu avant de vider le champ
  setTimeout(function() {
    if (input.value && input.getAttribute('aria-expanded') === 'true') {
      previousKlaviyoDropdownValues.set(input, input.value);
      setKlaviyoDropdownValue(input, '');
    }
  }, 0);
}

function restoreKlaviyoDropdownValue(input) {
  const value = previousKlaviyoDropdownValues.get(input);
  previousKlaviyoDropdownValues.delete(input);
  if (input.value || !value) return;

  // Remettre le texte suffit à la validation ; recliquer l'option ferme le menu
  // et rétablit la sélection Klaviyo
  setKlaviyoDropdownValue(input, value);
  setTimeout(function() {
    const menu = document.getElementById(input.getAttribute('aria-controls'));
    if (!menu) return;
    const option = Array.from(menu.querySelectorAll('[role="option"]')).find(function(item) {
      return item.innerText.trim() === value;
    });
    if (option) option.click();
  }, 50);
}

// Un clic sur une option retire d'abord le focus du champ (mousedown) : le focusout
// ci-dessous rétablirait alors l'ancien choix, Klaviyo filtrerait la liste et l'option
// cliquée disparaîtrait avant le clic. On garde donc le focus dans le champ pendant un
// clic dans son menu, comme le fait un menu Downshift standard.
document.addEventListener('mousedown', function(event) {
  const dropdown = getKlaviyoDropdown(event.target);
  if (!dropdown) return;
  const menu = event.target.closest('[role="listbox"]');
  if (menu && menu.id === dropdown.input.getAttribute('aria-controls')) event.preventDefault();
}, true);

document.addEventListener('click', showAllKlaviyoDropdownOptions);
document.addEventListener('keydown', function(event) {
  if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
    showAllKlaviyoDropdownOptions(event);
    return;
  }

  // Tab envoie le focus dans le menu ouvert (élément focusable de Klaviyo), ce que le
  // focusout ci-dessous ignore : on rétablit donc le choix dès la touche, comme pour Échap
  if (event.key === 'Tab' || event.key === 'Escape') {
    const dropdown = getKlaviyoDropdown(event.target);
    if (dropdown) restoreKlaviyoDropdownValue(dropdown.input);
  }
});
// Phase de capture : le texte doit être rétabli avant la validation de Klaviyo au blur,
// sinon le champ s'affiche « requis » le temps d'un clic
document.addEventListener('focusout', function(event) {
  const dropdown = getKlaviyoDropdown(event.target);
  if (!dropdown) return;
  if (event.relatedTarget && dropdown.field.contains(event.relatedTarget)) return;
  restoreKlaviyoDropdownValue(dropdown.input);
}, true);

// À l'envoi, Klaviyo remplace le formulaire par son message de confirmation (ou l'étape
// suivante), plus court : l'utilisateur se retrouve plus bas, hors du formulaire. On remonte
// en douceur jusqu'au titre de la page, sous l'en-tête collant. Seuls les formulaires du
// contenu principal sont concernés : l'infolettre du pied de page ne fait pas défiler.
window.addEventListener('klaviyoForms', function(event) {
  const detail = event.detail || {};
  if (detail.type !== 'submit' && detail.type !== 'stepSubmit') return;

  const container = document.querySelector('.klaviyo-form-' + detail.formId);
  if (!container || !container.closest('main')) return;

  const title = document.querySelector('main h1');
  if (!title) return;

  // Laisse Klaviyo afficher la confirmation avant de mesurer la position
  setTimeout(function() {
    const headerHeight = parseFloat(getComputedStyle(document.body).getPropertyValue('--header-height')) || 0;
    const top = title.getBoundingClientRect().top + window.scrollY - headerHeight - 16;
    if (top >= window.scrollY) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: Math.max(top, 0), behavior: reduceMotion ? 'auto' : 'smooth' });
  }, 100);
});
